import { render, staticRenderFns } from "./BetflixGamePanel.vue?vue&type=template&id=78845022&"
import script from "./BetflixGamePanel.vue?vue&type=script&lang=js&"
export * from "./BetflixGamePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports